import { render, staticRenderFns } from "./collection-banner-icon.vue?vue&type=template&id=41fbeb8e&functional=true&"
import script from "./collection-banner-icon.vue?vue&type=script&lang=js&"
export * from "./collection-banner-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports